;(function () {
   'use strict'

   angular
      .module('internalWebsiteApp')
      .controller(
         'ModalOdometerEditController',
         function ($scope, $uibModalInstance, logisticsData, alertService, util, truckload, onSubmitSuccess) {
            var ODOMETER_MAX_DELTA_MILES = 9999
            var ODOMETER_AUDIT_FIELD_LABELS = {
               odometer_start: 'Odometer Start',
               odometer_end: 'Odometer End',
            }

            $scope.truckload = truckload
            $scope.isEditable = !!truckload.odometerEditable

            // Modal view state: 'edit' or 'confirm'
            $scope.viewState = 'edit'

            // Form values
            $scope.formValues = {
               odometerStart: truckload.odometerStart,
               odometerEnd: truckload.odometerEnd,
               odometerReason: '',
            }

            // Audit history
            $scope.auditHistory = []
            $scope.auditLoading = true
            $scope.auditError = false
            $scope.showAuditHistory = false

            // Submission state
            $scope.submitting = false
            $scope.serverError = null

            // Validation
            $scope.validationErrors = {}

            // Normalize null/undefined/'' to null so comparisons are consistent.
            // ng-model on input[type=number] can produce null (cleared) or undefined
            // (untouched), while the API may return null or undefined for unset values.
            // Without normalization, null !== undefined would falsely report a change.

            function validateNonNegativeInteger(value, errorKey, errors) {
               if (!util.isNullishOrEmptyString(value) && (!Number.isInteger(value) || value < 0)) {
                  errors[errorKey] = 'Must be a non-negative integer.'
               }
            }

            function validate() {
               var errors = {}
               var start = $scope.formValues.odometerStart
               var end = $scope.formValues.odometerEnd

               validateNonNegativeInteger(start, 'odometerStart', errors)
               validateNonNegativeInteger(end, 'odometerEnd', errors)

               if (
                  !util.isNullishOrEmptyString(start) &&
                  !util.isNullishOrEmptyString(end) &&
                  !errors.odometerStart &&
                  !errors.odometerEnd
               ) {
                  if (end < start) {
                     errors.odometerEnd = 'End must be greater than or equal to start.'
                  } else if (end - start > ODOMETER_MAX_DELTA_MILES) {
                     errors.odometerEnd =
                        'Difference between start and end cannot exceed ' +
                        ODOMETER_MAX_DELTA_MILES.toLocaleString() +
                        ' miles.'
                  }
               }

               $scope.validationErrors = errors
               return Object.keys(errors).length === 0
            }

            function buildDeltaPreview() {
               var startOld = util.toNumberOrNull(truckload.odometerStart)
               var endOld = util.toNumberOrNull(truckload.odometerEnd)
               var startNew = util.toNumberOrNull($scope.formValues.odometerStart)
               var endNew = util.toNumberOrNull($scope.formValues.odometerEnd)

               var startChanged = startOld !== startNew
               var endChanged = endOld !== endNew

               var totalOld = startOld !== null && endOld !== null ? endOld - startOld : null
               var totalNew = startNew !== null && endNew !== null ? endNew - startNew : null

               return {
                  hasChanges: startChanged || endChanged,
                  startChanged: startChanged,
                  endChanged: endChanged,
                  startOld: startOld,
                  startNew: startNew,
                  startDelta: startOld !== null && startNew !== null ? startNew - startOld : null,
                  endOld: endOld,
                  endNew: endNew,
                  endDelta: endOld !== null && endNew !== null ? endNew - endOld : null,
                  totalOld: totalOld,
                  totalNew: totalNew,
                  totalDelta: totalOld !== null && totalNew !== null ? totalNew - totalOld : null,
               }
            }

            // Build the changes summary for confirmation
            function buildChangesSummary(deltaPreview) {
               var changeFields = [
                  {
                     changedKey: 'startChanged',
                     field: 'Odometer Start',
                     shortField: 'Start',
                     oldValueKey: 'startOld',
                     newValueKey: 'startNew',
                     deltaKey: 'startDelta',
                  },
                  {
                     changedKey: 'endChanged',
                     field: 'Odometer End',
                     shortField: 'End',
                     oldValueKey: 'endOld',
                     newValueKey: 'endNew',
                     deltaKey: 'endDelta',
                  },
               ]

               return changeFields.reduce(function (changes, changeField) {
                  if (!deltaPreview[changeField.changedKey]) {
                     return changes
                  }

                  changes.push({
                     field: changeField.field,
                     shortField: changeField.shortField,
                     oldValue: deltaPreview[changeField.oldValueKey],
                     newValue: deltaPreview[changeField.newValueKey],
                     delta: deltaPreview[changeField.deltaKey],
                  })

                  return changes
               }, [])
            }

            function getSubmitErrorMessage(status, data) {
               if (status === 409) {
                  return 'Another user has modified this record. Please close and try again.'
               }
               if (status === 400 && data && data.message) {
                  return data.message
               }
               return null
            }

            $scope.formatValue = function (value) {
               var normalizedValue = util.normalizeNullishOrEmptyStringToNull(value)
               if (normalizedValue === null) {
                  return 'Not set'
               }
               return Number(normalizedValue).toLocaleString()
            }

            $scope.deltaPreview = buildDeltaPreview()

            $scope.getDeltaClass = function (delta) {
               if (delta === null || delta === undefined || delta === 0) {
                  return 'text-gray-600'
               }
               return delta > 0 ? 'text-green-700' : 'text-red-700'
            }

            $scope.getDeltaLabel = function (oldValue, newValue, delta) {
               var normalizedOldValue = util.normalizeNullishOrEmptyStringToNull(oldValue)
               var normalizedNewValue = util.normalizeNullishOrEmptyStringToNull(newValue)

               if (normalizedOldValue === null && normalizedNewValue !== null) {
                  return 'set'
               }
               if (normalizedOldValue !== null && normalizedNewValue === null) {
                  return 'cleared'
               }
               if (delta === null || delta === undefined) {
                  return ''
               }
               if (delta === 0) {
                  return '±0'
               }
               return (delta > 0 ? '+' : '') + Number(delta).toLocaleString()
            }

            $scope.$watchGroup(['formValues.odometerStart', 'formValues.odometerEnd'], function () {
               $scope.deltaPreview = buildDeltaPreview()
            })

            // Load audit history
            logisticsData
               .getOdometerAudit(truckload.id)
               .then(function (entries) {
                  $scope.auditHistory = entries
               })
               .catch(function () {
                  $scope.auditError = true
               })
               .finally(function () {
                  $scope.auditLoading = false
               })

            // Review Changes button - validate and move to confirmation state
            $scope.reviewChanges = function () {
               $scope.serverError = null

               if (!validate()) {
                  return
               }

               var deltaPreview = buildDeltaPreview()
               if (!deltaPreview.hasChanges) {
                  $scope.serverError = 'No changes have been made.'
                  return
               }

               $scope.deltaPreview = deltaPreview
               $scope.changesSummary = buildChangesSummary(deltaPreview)
               $scope.viewState = 'confirm'
            }

            // Back button from confirmation
            $scope.backToEdit = function () {
               $scope.viewState = 'edit'
               $scope.serverError = null
            }

            // Confirm and submit
            $scope.confirmSubmit = function () {
               // Guard against double-click: ng-disabled="submitting" prevents clicks
               // after Angular's digest cycle, but a fast double-click can fire twice
               // before the DOM updates. This early return prevents duplicate PATCH requests.
               if ($scope.submitting) {
                  return
               }

               $scope.submitting = true
               $scope.serverError = null

               var payload = {
                  odometerStart: $scope.formValues.odometerStart,
                  odometerEnd: $scope.formValues.odometerEnd,
                  odometerReason: $scope.formValues.odometerReason || '',
                  version: truckload.version,
               }

               logisticsData
                  .patchTruckloadOdometer(truckload.id, payload)
                  .then(function (updatedTruckload) {
                     onSubmitSuccess(updatedTruckload)
                     $uibModalInstance.close()
                     alertService.successMessage('Odometer readings updated successfully.')
                  })
                  .catch(function (error) {
                     var status = error && error.status
                     var data = error && error.data
                     var submitErrorMessage = getSubmitErrorMessage(status, data)

                     if (submitErrorMessage) {
                        $scope.serverError = submitErrorMessage
                     } else {
                        $scope.serverError = 'An error occurred while saving. Please try again.'
                        console.error('Odometer update error:', error)
                     }

                     $scope.viewState = 'edit'
                  })
                  .finally(function () {
                     $scope.submitting = false
                  })
            }

            // Format audit timestamp
            $scope.formatTimestamp = function (timestamp) {
               if (!timestamp) {
                  return ''
               }

               var d = new Date(timestamp)
               return (
                  d.getMonth() +
                  1 +
                  '/' +
                  d.getDate() +
                  '/' +
                  d.getFullYear() +
                  ' ' +
                  d.toLocaleTimeString('en-US', {
                     hour: 'numeric',
                     minute: '2-digit',
                     hour12: true,
                  })
               )
            }

            // Format audit field name for display
            $scope.formatFieldName = function (field) {
               return ODOMETER_AUDIT_FIELD_LABELS[field] || field
            }

            $scope.toggleAuditHistory = function () {
               $scope.showAuditHistory = !$scope.showAuditHistory
            }
         },
      )
})()
